import { useEffect, useRef } from 'react';

// Calls onIdle() after `timeoutMs` of no user activity (mouse, keyboard, touch, scroll).
export default function useIdleLogout(timeoutMs, onIdle) {
  const timerRef = useRef(null);

  useEffect(() => {
    function reset() {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(onIdle, timeoutMs);
    }

    const events = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, [timeoutMs, onIdle]);
}
